import { lazy, Suspense } from "react";

type ThroughputSeriesKey = "Received" | "Sent";

type ThroughputChartRow = {
  t: string;
  iso: string;
  Received: number;
  Sent: number;
  Total: number;
};

const ThroughputChartSurfaceImpl = lazy(
  () => import("./throughput-chart-surface-impl"),
);

export function ThroughputChartSurface(props: {
  idPrefix: string;
  data: ThroughputChartRow[];
  yAxisMax: number;
  visibleSeries: Record<ThroughputSeriesKey, boolean>;
  rxLimitBps?: number;
  txLimitBps?: number;
  sharedLimitBps?: number;
  valueFormatter?: (value: number) => string;
  pdfMode?: boolean;
}) {
  return (
    <Suspense fallback={null}>
      <ThroughputChartSurfaceImpl {...props} />
    </Suspense>
  );
}
